import { Component, OnInit, Input } from '@angular/core';
import { DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'ae-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss']
})
export class CustomModalComponent implements OnInit {
  constructor(public dialogData: DialogConfig, private router: Router) {}
  currentUrl: string;
  renewalflag: boolean = false;
  ceContactFlad: boolean = false;
  currentSubcompany: string;
  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.renewalflag = this.currentUrl.includes('renewalreview');
    this.ceContactFlad = this.currentUrl.includes('losspayee');
    if(sessionStorage.getItem('productName') != null){
      this.currentSubcompany = sessionStorage.getItem('productName').replace("'","");
    }
    else{
      this.currentSubcompany ="";
    }
    
  }
  callback() {
    if (this.dialogData.data.footerBtnCallback) {
      this.dialogData.data.footerBtnCallback();
    }
  }
  closePopup() {
    this.dialogData.data.noBtnCallback();
  }
  yesPopup() {
    this.dialogData.data.yesBtnCallback();
  }
}
